const header = () => {
	const header = document.querySelector('.header');
	const hero   = document.getElementById('hero');

	if (hero) {
		const heroHeight = hero.clientHeight;
		document.addEventListener('scroll', () => {
			if (window.scrollY > heroHeight) {
				header.classList.add('header--light');
			} else {
				header.classList.remove('header--light');
			}
		});
	}
};
export default header;
